import moment from "moment";

export const getCurrentUTCEpochTime = (): number => {
  try {
    return moment.utc().valueOf();
  } catch {
    return 0;
  }
};
